const adminsPhone = [
  '3234910173',
  '3188317011',
  '3117405761',
  '3123898150'
];

export default adminsPhone;
